import * as tslib_1 from "tslib";
import { ElementRef, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { select, Store } from '@ngrx/store';
import { get } from 'lodash';
import { filter, take, tap } from 'rxjs/operators';
import { FacebookPixelEventTrackerService } from 'src/app/facebook-pixel-event-tracker.service';
import { CourseLecture } from '../../services/course-data.service';
import * as courseSelectors from '../../state/courses/selectors';
import * as ui from '../../state/ui';
import { VideoComponent } from '../../videoComponent';
var LectureComponent = /** @class */ (function (_super) {
    tslib_1.__extends(LectureComponent, _super);
    function LectureComponent(domSanitizer, store, facebookPixelEventTracker) {
        var _this = _super.call(this, store, facebookPixelEventTracker) || this;
        _this.domSanitizer = domSanitizer;
        _this.lecture = null;
        _this.layout = 'main';
        _this.showVideo = true;
        _this.playerControlsDisabled = false;
        _this.showDownloadNotice = false;
        _this.currentSelection = 'lecture';
        return _this;
    }
    Object.defineProperty(LectureComponent.prototype, "lectureVideoRef", {
        get: function () { return this.playerVideoRef; },
        set: function (value) { this.playerVideoRef = value; },
        enumerable: true,
        configurable: true
    });
    LectureComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.curLocationLookupSub = this.store.pipe(select(courseSelectors.getVideoLoc(), { videoId: this.lecture.video_id }), filter(function (i) { return i; }), tap(function (i) { return console.log('video-loc', i); }), take(1)).subscribe(function (position) {
            _this.videoStartPosition = position.position;
            _this.setPositionIfNotStartedAndNotAtEndOfVideo();
        });
    };
    LectureComponent.prototype.ngOnDestroy = function () {
        if (this.curLocationLookupSub && !this.curLocationLookupSub.closed) {
            this.curLocationLookupSub.unsubscribe();
        }
        if (this.modalWatcherSub && !this.modalWatcherSub.closed) {
            this.modalWatcherSub.unsubscribe();
        }
    };
    LectureComponent.prototype.ngOnChanges = function (changes) {
        // console.log('change', changes, this.lecture, this.showVideo);
        if (changes.lecture || changes.showVideo) {
            var videoIdIsSame = get(changes, 'lecture.currentValue.video_id') === get(changes, 'lecture.previousValue.video_id');
            var showVideoIsSame = get(changes, 'showVideo.currentValue') === get(changes, 'showVideo.previousValue');
            if (videoIdIsSame && showVideoIsSame) {
                console.log('"change" to lecture, but the same video');
                return;
            }
            if (this.lecture && this.showVideo) {
                // console.log('got lecture', changes.lecture.currentValue, this.showVideo);
                this.clearPreviousVideoPlayer();
                this.loadVideo(this.lecture.video_id, true, this.lecture.system_id);
            }
            else if (!this.showVideo && !showVideoIsSame) {
                if (this.player) {
                    this.player.pause();
                    this.clearPreviousVideoPlayer();
                }
                //stop watching for modal changes
                if (this.modalWatcherSub != null && !this.modalWatcherSub.closed) {
                    this.modalWatcherSub.unsubscribe();
                }
            }
        }
    };
    LectureComponent.prototype.onPlayerInit = function () {
        var _this = this;
        this.setPositionIfNotStartedAndNotAtEndOfVideo();
        this.modalWatcherSub = this.store.pipe(select(ui.selectModalStatus)).subscribe(function (modalOpen) {
            if (!_this.player)
                return;
            //if the player is playing and a modal just opened, pause the video
            if (!_this.player.paused() && modalOpen) {
                console.log('paused the video');
                _this.player.pause();
            }
        });
    };
    LectureComponent.prototype.setPositionIfNotStartedAndNotAtEndOfVideo = function () {
        if (!this.player || this.videoStarted || !this.videoStartPosition)
            return;
        var duration = this.getVideoDuration();
        console.log('last position', this.videoStartPosition, '; video duration', duration);
        if (!duration || duration.duration - 30 > this.videoStartPosition) {
            this.player.currentTime(this.videoStartPosition);
            //if the soundcloud widget has loaded, then set its start time too
            if (this.soundCloudWidget) {
                this.soundCloudWidget.seekTo(this.videoStartPosition * 1000);
            }
        }
        else {
            console.log('video is completed. Not setting position');
        }
    };
    LectureComponent.prototype.getVideoDuration = function () {
        var playerDur = this.player && this.player.duration();
        if (playerDur)
            return { type: 'player', duration: playerDur };
        //could not get duration from player (https://docs.videojs.com/player#duration)
        //lets try parsing the "duration" property on the lecture
        var parts = this.lecture && this.lecture.duration && this.lecture.duration.split(':');
        if (parts && parts.length === 2) {
            var minutes = parseInt(parts[0], 10);
            var seconds = parseInt(parts[1], 10);
            //if we got valid numbers from both parts, just convert the minutes and seconds to seconds and return
            if (!Number.isNaN(seconds) && !Number.isNaN(minutes)) {
                return { type: 'lecture', duration: 60 * minutes + seconds };
            }
        }
        //unable to find duration. Return nothing
        return null;
    };
    LectureComponent.prototype.parseVideoIDIntoSrc = function (videoID) {
        var parsedID;
        if (videoID) {
            videoID = videoID.toString();
            if (videoID.includes('/')) {
                if (videoID.includes('showcase')) {
                    parsedID = this.domSanitizer.bypassSecurityTrustResourceUrl('https://vimeo.com/' + videoID + '/embed');
                }
                else {
                    parsedID = this.domSanitizer.bypassSecurityTrustResourceUrl('https://player.vimeo.com/video/' + videoID.split('/')[0] + '?h=' + videoID.split('/')[1]);
                }
            }
            else {
                parsedID = this.domSanitizer.bypassSecurityTrustResourceUrl('https://player.vimeo.com/video/' + videoID);
            }
        }
        return parsedID;
    };
    return LectureComponent;
}(VideoComponent));
export { LectureComponent };
